import { createGlobalStyle } from 'styled-components'

const GlobalStyles = createGlobalStyle`
  body {
    user-select: none;
    background: #efefef;
    padding: 0;
    margin: 0;
    font-family: 'Roboto', 'Helvetica', sans-serif
  }
`

export default GlobalStyles
